export default "__VITE_ASSET__D0mb3FvD__"